import {
  Text,
  View,
  useWindowDimensions,
  TextStyle,
  ViewStyle,
} from 'react-native';
import React from 'react';
import {Navbar} from './Navbar';
import {spacing} from 'theme/Units';

import {Button} from 'ui-kits';
import {colors} from 'theme/Colors';
import Marquee from './Marquee';
import {AnimatedCircle} from 'components/common';
import {v4 as uuidv4} from 'uuid';
import {staticDataForScreen} from 'constants/DefaultValues';

const {circles: ENTITIES} = staticDataForScreen.landing_screen.heroSection;

type propType = Readonly<{
  openModal: () => void;
  nagivateToLogin: () => void;
  nagivateToSignup: () => void;
}>;

export function Hero(props: propType) {
  const {nagivateToSignup, nagivateToLogin} = props;
  const {width: SCREEN_WIDTH} = useWindowDimensions();

  const overridestyle = structuredClone(styles);
  let circleScale = 1;
  if (SCREEN_WIDTH < 1024) {
    overridestyle.content.paddingHorizontal = spacing['10'];
    overridestyle.content.paddingVertical = spacing['6'];
    overridestyle.heading.fontSize = 44;
    overridestyle.paragraph.fontSize = 18;
    overridestyle.container.gap = spacing['8'];
  }
  if (SCREEN_WIDTH < 720) {
    overridestyle.content.paddingHorizontal = spacing['8'];
    overridestyle.content.paddingVertical = spacing['5'];
    overridestyle.heading.fontSize = 38;
    overridestyle.paragraph.fontSize = 16;
    overridestyle.container.gap = spacing['6'];
  }
  if (SCREEN_WIDTH < 640) {
    overridestyle.content.paddingHorizontal = spacing['6'];
    overridestyle.content.paddingVertical = spacing['4'];
    overridestyle.heading.fontSize = 34;
    overridestyle.paragraph.fontSize = 14;
    overridestyle.container.gap = spacing['4'];
    circleScale = 0.8;
  }
  if (SCREEN_WIDTH < 480) {
    overridestyle.content.paddingHorizontal = spacing['4'];
    overridestyle.heading.fontSize = 28;
    overridestyle.paragraph.fontSize = 12;
    overridestyle.container.gap = spacing['2'];
    circleScale = 0.6;
  }
  if (SCREEN_WIDTH < 360) {
    overridestyle.container.gap = 0;
  }

  // component to display bg animation as an overlay
  const backGroundAnimation = (
    <View style={styles.background}>
      {Array(100)
        .fill(0)
        .map(_ => {
          const uniqueKey = uuidv4();
          return <View key={uniqueKey} style={styles.strip} />;
        })}

      <AnimatedCircle
        duration={2500}
        circleScale={circleScale}
        entities={ENTITIES}
      />
    </View>
  );



  return (
    <View style={[styles.container, overridestyle.container]}>
      {/* bg animation component */}
      {backGroundAnimation}

      {/* main content */}
      <View style={[styles.content, overridestyle.content]}>
        <Navbar nagivateToLogin={nagivateToLogin}/>
        <Text style={[styles.heading, overridestyle.heading]}>
          Supercharge Your Development:{'\n'}
          All-In-One Portal for Ultimate Efficiency
        </Text>
        <Text style={[styles.paragraph, overridestyle.paragraph]}>
          Experience seamless collaboration, AI-powered insights, and automated
          workflows designed to accelerate your projects and{'\n'}simplify your
          processes—all in one secure, centralized hub.
        </Text>

        {/* sign in button */}
        <Button
          style={styles.singInButton}
          onPress={nagivateToSignup}
          variant="secondary"
          textStyle={styles.singInButtonText}
          text="Sign Up of 1IDP"
        />
      </View>

      {/* watermark images */}
      <Marquee />
    </View>
  );
}

type styleType = {
  heading: TextStyle;
  paragraph: TextStyle;
  container: ViewStyle;
  content: ViewStyle;
  background: ViewStyle;
  strip: ViewStyle;
  singInButton: ViewStyle;
  singInButtonText: TextStyle;
};

const styles: styleType = {
  singInButtonText: {color: 'black', fontWeight: '600'},
  singInButton: {
    alignSelf: 'center',
    borderColor: colors.palette.brandBlue,
    borderWidth: 1,
  },
  heading: {
    color: 'white',
    fontSize: 50,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  paragraph: {
    color: 'white',
    textAlign: 'center',
    fontSize: 20,
  },
  container: {
    gap: spacing['10'],
    backgroundColor: 'black',
  },
  background: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(100, 5%)',
    overflow: 'hidden',
  },
  strip: {
    height: '100%',
    backgroundImage:
      'linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.1) 77%, rgba(255,255,255, .2) 100%)',
    backdropFilter: 'blur(40px)',
    opacity: 0.4,
  },
  content: {
    gap: spacing['10'],
    paddingHorizontal: spacing['12'],
    paddingVertical: spacing['8'],
  },
};
